import React, { useState } from 'react';
import './DogPhotoGallery.css';

const dogPhotos = [
  '/images/Hazel-1.jpg',
  '/images/Hazel-2.jpg',
  '/images/Hazel-3.jpg',
  '/images/Hazel-4.jpg',
  '/images/Hazel-5.jpg',
];

const DogPhotoGallery: React.FC = () => {
  const [current, setCurrent] = useState(0);

  const prevPhoto = () => setCurrent((current - 1 + dogPhotos.length) % dogPhotos.length);
  const nextPhoto = () => setCurrent((current + 1) % dogPhotos.length);

  return (
    <div className="carousel-container">
      <h1>Hazel Hackers</h1>
      <div style={{ textAlign: 'center', color: 'white', marginBottom: '10px' }}>
        created by{' '}
        <a href="https://moma.corp.google.com/person/edrienne" style={{ color: 'white', textDecoration: 'underline' }}>@edrienne</a>,{' '}
        <a href="https://moma.corp.google.com/person/EMMAMUNLEY" style={{ color: 'white', textDecoration: 'underline' }}>@emmamunley</a>,{' '}
        <a href="https://moma.corp.google.com/person/matthewladdy" style={{ color: 'white', textDecoration: 'underline' }}>@matthewladdy</a>
      </div>
      <div className="carousel">
        <button className="carousel-btn" onClick={prevPhoto} aria-label="Previous photo">
          &#8592;
        </button>
        <img
          className="carousel-img"
          src={dogPhotos[current]}
          alt={`A dog named Hazel ${current + 1}`}
          onError={e => (e.currentTarget.src = '/fallback-dog.jpg')}
        />
        <button className="carousel-btn" onClick={nextPhoto} aria-label="Next photo">
          &#8594;
        </button>
      </div>
      <div className="carousel-indicators">
        {dogPhotos.map((_, idx) => (
          <span
            key={idx}
            className={`indicator${idx === current ? ' active' : ''}`}
            onClick={() => setCurrent(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default DogPhotoGallery;